// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/css/font-awesome.css
// module id = ./node_modules/font-awesome/css/font-awesome.css
// module chunks = 1